






































































import { Component, Vue, Watch } from "vue-property-decorator";
import { DataPoint } from "../models";
import GenderIcon from "../components/GenderIcon.vue";
import NameStreamGraph from "../components/NameStreamGraph.vue";
import { mdiFire } from "@mdi/js";
@Component({
  components: {
    GenderIcon,
    NameStreamGraph
  },
  mounted() {
    this.getPopularity(2013, 2018, 10, 1000000);
    fetch(`${process.env.VUE_APP_API_ROOT}/minmax-years`)
      .then(res => res.json())
      .then((data: any) => {
        const { minYear, maxYear } = data;
        this.$data.minYear = minYear;
        this.$data.maxYear = maxYear;
      });
  }
})
export default class Popularity extends Vue {
  minYear = 1996;
  maxYear = 2018;

  yearRange = [2013, 2018];
  popularityRange = [0, 4];

  search = "";

  expanded = [];
  nameData: DataPoint[] = [];

  mdiFire = mdiFire;
  popularityResponse: {
    averageCount: number;
    name: string;
    growth: number;
    gender: string;
  }[] = [];

  headers = [
    { text: "Name", value: "name", sortable: false },
    { text: "Avg. Births", value: "averageCount" },
    {
      text: "Growth",
      value: "growth",
      sort: (a: string, b: string) => {
        const aAsNumber = Number(a.replace("%", ""));
        const bAsNumber = Number(b.replace("%", ""));
        return aAsNumber - bAsNumber;
      }
    },
    { text: "Heat", value: "heat" },
    { value: "data-table-expand" }
  ];

  loading = false;

  get rowData() {
    const numberOfyears = this.yearRange[1] - this.yearRange[0];

    return this.popularityResponse.map(record => ({
      ...record,
      id: `${record.name}${record.gender}`,
      averageCount: Math.round(record.averageCount),
      growth: `${Math.round((record.growth - 1) * 100)}%`,
      heat: Math.round(
        (Math.pow(record.averageCount, 1 / 2) * record.growth) /
          (numberOfyears || 1)
      )
    }));
  }

  async getPopularity(
    startYear: number,
    endYear: number,
    minCount: number,
    maxCount: number
  ) {
    this.loading = true;
    this.popularityResponse = [];
    const response = await fetch(
      `${process.env.VUE_APP_API_ROOT}/names/popularity?startYear=${startYear}&endYear=${endYear}&minCount=${minCount}&maxCount=${maxCount}`
    );
    const results = await response.json();

    this.loading = false;
    if (this.yearRange[0] === startYear && this.yearRange[1] === endYear)
      this.popularityResponse = results;
  }

  @Watch("yearRange")
  async onYearRangeChange(val: [number, number]) {
    this.getPopularity(
      val[0],
      val[1],
      Math.pow(10, this.popularityRange[0]),
      Math.pow(10, this.popularityRange[1])
    );
  }

  @Watch("popularityRange")
  async onPopularityRangeChange(val: [number, number]) {
    this.getPopularity(
      this.yearRange[0],
      this.yearRange[1],
      Math.pow(10, val[0]),
      Math.pow(10, val[1])
    );
  }

  @Watch("expanded")
  async onExpandedChange(val: any[]) {
    this.nameData = [];
    fetch(
      `${process.env.VUE_APP_API_ROOT}/births/${val[0].name}/gender/${val[0].gender}`
    )
      .then(res => res.json())
      .then(js => {
        this.nameData = js;
      });
  }
}
